fragment baseEntryFields on EntryInterface {
    id
    siteId
    slug
    uri
    url
    title
    postDate
    entryType: typeHandle
    __typename
    translations: localized {
        uri
        url
        language
    }
}
